import gql from 'graphql-tag'
import { areaSimpleFragment } from 'graphqlAPI/areas/fragments'

export const courseUserFragment = gql`
  fragment CourseUserFragment on CourseUser {
    courseId
    userId
    advance
    evaluationsState
    user {
      active
      identifier
      name
      lastname
      position
      avatar
      roleId
    }
    area {
      ...AreaFragmentSimple
    }
    overallProgress
    assignedLessons
    mandatory
    evaluations {
      id
      points
      blockEvaluationId
      correct
      approved
    }
    enrol {
      integrationStatus
    }
    synchronousCourseEvaluations {
      id
      position
      qualification
    }
    synchronousCourseEnrol {
      finalState
      attendance
    }
    certificatesCount
  }
  ${areaSimpleFragment}
`
